// import { GenaiAgentAssist } from '@brightspeed/app-genai-agent-assist';
import { useState } from 'react';
import AgentAssist from 'src/components/wrapper/agent-assist';
import { useMsal } from '@azure/msal-react';
import SalesScriptHeader from '../../components/sales-script-header';
import { imageSources, screenData } from './screen-data';

interface User {
	name: string;
	email: string;
}

const SalesScript: React.FC = () => {
	const [currentStep, setCurrentStep] = useState(1);
	const [chatData, setChatData] = useState(screenData[currentStep - 1]);

	const handleImageClick = () => {
		if (currentStep < 23) {
			setCurrentStep(currentStep + 1);
		}
		setChatData(screenData[currentStep]);
	};
	const getImageSource = () => {
		return imageSources[currentStep - 1] || '';
	};
	// logged in user details
	const { instance } = useMsal();
	const accounts = instance.getAllAccounts();
	const loggedInUserName = accounts && accounts.length > 0 ? accounts[0].name : '';
	const loggedInUserEmail = accounts && accounts.length > 0 ? accounts[0].username : '';

	const loggedInUserData: User = {
		name: loggedInUserName || '',
		email: loggedInUserEmail || '',
	};
	return (
		<>
			<div className="bg-[#e4e4e4] w-full min-h-[100vh] p-4">
				<SalesScriptHeader title="New Customer Order" />
				<div className="grid grid-cols-4 gap-4 pb-44">
					<div>
						<AgentAssist data={chatData} loggedInUserData={loggedInUserData} />
						{/* <GenaiAgentAssist data={chatData} loggedInUserData={loggedInUserData} /> */}
					</div>
					<div className="col-span-2">
						<div>
							<img
								className={`cursor-pointer ${currentStep >= 23 ? 'pointer-events-none' : ''}`}
								src={getImageSource()}
								alt={`Screen ${currentStep}`}
								onClick={handleImageClick}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default SalesScript;
